import { IOptions } from '@/shared/options';

export const INSIGHT_TOP_SKILLS_LIMIT = 10;

/** Горилогчдын хамгийн их давтагдсан ур чадварууд (давтамжаар буурахаар). */
export function getTopSkillItems(items: (IOptions & { count: number })[]) {
  return [...items]
    .filter((item) => item.count > 0)
    .sort((a, b) => b.count - a.count)
    .slice(0, INSIGHT_TOP_SKILLS_LIMIT);
}
